import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

import { basicDetailModalFallback } from '@/content/sessionCatalogBundles/sessionDetailModalFallbacks'

const nullImage = { assetId: '', alt: '', width: 0, height: 0, url: '' }

export const basicBundleFallback: BookingSessionBundle = {
  internalName: 'Bundle: Basic',
  identifier: '',
  title: 'Basic',
  orderSummaryFriendlyName: '',
  tagline: '',
  features: '',
  highlightedFeatures: '',
  listingImage: nullImage,
  listingImageMobile: nullImage,
  badgeLabel: '',
  ctaLabel: '',
  priceLabel: '',
  showPrice: true,
  selectLabel: '',
  recommendedLabel: '',
  galleryLabel: '',
  detailsLabel: '',
  detailPageSlug: '',
  includedScenesLabel: '',
  cartSummaryFeatures: '',
  featureBulletItems: [] as never,
  galleryImages: [],
  upgradeModal: null,
  sessionsListingUpgradeModal: null,
  sceneSelectionPage: null,
  addOnsSelectionPage: null,
  detailPage: null,
  sessionDetailModal: basicDetailModalFallback,
  valueDetails: {
    internalName: '',
    restricted: true,
    restrictedWarningText: '',
    restrictedWarningCheckboxLabel: '',
    selectionAlertText: '',
    trending: false,
    trendingLabel: '',
    creditBadgeLabel: '',
    promoText: '',
    promoHighlight: ''
  }
} as unknown as BookingSessionBundle
